import { render, staticRenderFns } from "./LoanTerms.vue?vue&type=template&id=28c8fdc9&lang=pug&"
import script from "./LoanTerms.vue?vue&type=script&lang=js&"
export * from "./LoanTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports